<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-inexorange hover:text-white" :href="route('forexs')">Parámetro</inertia-link>
      <span class="text-white font-medium">/Crear</span> 
    </h1>
    <div class="bg-transparent rounded-md shadow overflow-hidden max-w-4xl">
      <form @submit.prevent="store" >
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <div class="pr-6 pb-8 w-full lg:w-6/6">
           <label style="color: white; font-weight: 700;" class="form-label" >Pares:</label>
            <VueMultiselectComponent
              class="form-input bg-inexinput text-inexorange  border-inexgray focus:border-inexorange w-full"
              v-model="form.tipo"
              :options="options"
            />
          </div>
          <div class="pr-6 pb-8 w-full lg:w-2/6">
           <label style="color: white; font-weight: 700;" class="form-label" >Fecha:</label>
           <datepicker v-model="form.fecha" :language="es" name="uniquename" input-class="form-input bg-inexinput text-white border-inexgray focus:border-inexorange w-full"></datepicker>
          </div>
          <text-input v-model="form.dinero_ganado" :error="form.errors.dinero_ganado" class="pr-6 pb-8 w-full lg:w-2/6" label="Total $ ganado" required/>
          <text-input v-model="form.dinero_perdido" :error="form.errors.dinero_perdido" class="pr-6 pb-8 w-full lg:w-2/6" label="Total $ perdido" required/>

         
          <text-input v-model="form.total_traders" :error="form.errors.total_traders" class="pr-6 pb-8 w-full lg:w-2/6" label="Operaciones totales" required/>
          <text-input v-model="form.total_ganadas" :error="form.errors.total_ganadas" class="pr-6 pb-8 w-full lg:w-2/6" label="Operaciones ganadas" required/>
          <text-input v-model="form.total_perdidas" :error="form.errors.total_perdidas" class="pr-6 pb-8 w-full lg:w-2/6" label="Operaciones perdidas" required/>
          <text-input v-model="form.total_swap" :error="form.errors.total_swap" class="pr-6 pb-8 w-full lg:w-2/6" label="Total $ SWAP" required/>
          <text-input v-model="form.total_comision" :error="form.errors.total_comision" class="pr-6 pb-8 w-full lg:w-2/6" label="Total $ Comisión" required/>
          <text-input v-model="form.volumen" :error="form.errors.volumen" class="pr-6 pb-8 w-full lg:w-2/6" label="Total volumen" required/>


            
          <br><br>
        </div>
        <div class="px-8 py-4 bg-transparent flex justify-end items-center">
          <loading-button :loading="form.processing" style="color: white;" class="px-8 py-4 btn-indigoOrange" type="submit">CREAR PARÁMETRO</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Datepicker from 'vuejs-datepicker';
import {en, es} from 'vuejs-datepicker/dist/locale'
import VueMultiselectComponent from 'vue-multiselect-component'




export default {
  metaInfo: { title: 'Crear Parametro' },
  components: {
    FileInput,
    LoadingButton,
    SelectInput,
    TextInput,
    Datepicker,
    VueMultiselectComponent,
  },
  layout: Layout,
  props: {
    opciones: Array,
  },
  remember: 'form',
  data() {
    return {
      es: es,
      options: this.opciones,
      form: this.$inertia.form({
        total_traders: null,
        total_ganadas: null,
        total_perdidas: null,
        total_compras: null,
        total_ventas: null,
        total_swap: null,
        total_comision: null,
        tiempo_promedio: null,
        dinero_ganado: null,
        dinero_perdido: null,
        tipo: [],
        fecha: null,
        volumen: null,
      }),
    }
  },
  methods: {
    store() {
      var total_traders=parseInt(this.form.total_ganadas)+parseInt(this.form.total_perdidas);
      var total_operaciones = parseInt(this.form.total_compras)+parseInt(this.form.total_ventas);
      if(this.form.total_traders!=total_traders ){
        alert(total_traders);
        alert('Las operaciones no coinciden!')
      }
      else{
          this.form.post(this.route('forexs.store'))
      }
    },
  },
}
</script>
